import {ReactComponent as GreenLine} from '../../../../assets/logos/pink-line.svg'
import './index.scss'
import {useAnimation, motion} from "framer-motion"
import { useInView } from "react-intersection-observer";
import { useEffect } from 'react';
import { container, child4 } from "../../../../variants"

const geoLine = <GreenLine id='orange'/>

const GeoFenceMerits = () => {
    const merits = [
        {id:"merit1", icon:geoLine, title:"Enhanced Productivity", cont:"Real-time tracking optimizes resource allocation, ensuring tasks are efficiently managed and completed on time."},
        {id:"merit2", icon:geoLine, title:"Improved Safety Measures", cont:" Instant location monitoring enables swift response to emergencies, enhancing employee safety and reducing risks."},
        {id:"merit3", icon:geoLine, title:"Streamlined Operations", cont:"Seamless integration simplifies attendance management, payroll processing, and task allocation, leading to smoother workflows and cost savings."}
    ]

    const ctrls = useAnimation();

    const { ref, inView } = useInView({
        threshold: 0.2,
        triggerOnce: false,
    });

    useEffect(() => {
        if (inView) {
            ctrls.start("visible");
        }
        if (!inView) {
            ctrls.start("hidden");
        }
    }, [ctrls, inView])

  return (
    <motion.div ref={ref} variants={container} initial="hidden" animate={ctrls} id="Merits" className='geo-merits d-flex flex-row justify-content-center'>
        <motion.ul className='pro-center d-flex flex-row justify-content-between align-items-start'>
            {merits.map((each)=> {
                return <motion.li className='d-flex flex-column justify-content-center merits-cont' key={each.id}>
                    <div className='d-flex flex-row'>
                        <span className='green-line'>{each.icon}</span>
                        <motion.h3 variants={child4} className='text-18 font-weight-600 merit-head'>{each.title}</motion.h3>
                    </div>
                    <p className=' font-weight-400 p-size merit-para'>{each.cont}</p>
                </motion.li>
            })}
        </motion.ul>
    </motion.div>
  )
}
export default GeoFenceMerits